<div class="popup-container">
    <div class="popup-header">
        <h3 class="m-0">Colli già in viaggio ({{ data.parcelsInTrip.length }})</h3>
    </div>

    <div class="popup-body">
        <table class="table table-sm table-striped mb-0">
            <thead class="table-light">
            <tr>
                <th>Collo</th>
                <th>Bolla</th>
                <th>Viaggio</th>
                <th>Destinazione</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let parcel of data.parcelsInTrip">
                <td>{{ parcel.parcelCode }}</td>
                <td>{{ parcel.parcelWaybillCode }}<span *ngIf="parcel.parcelShipmentCode" class="text-muted"> / {{ parcel.parcelShipmentCode }}</span></td>
                <td>{{ parcel.tripCode }}</td>
                <td>{{ parcel.destinationName || parcel.destinationCode }}</td>
            </tr>
            </tbody>
        </table>
    </div>

    <div class="popup-footer d-flex justify-content-end">
        <button type="button" class="btn btn-light" (click)="close()">
            <i class="fas fa-times me-2"></i>
            Chiudi
        </button>
    </div>
</div>
